import React from "react";
import LegalLayout, { H2, H3, P, UL, Field } from "./LegalLayout";

const CONTACT = "contact@teamlooking-4.fr";

export function MentionsLegales() {
  return (
    <LegalLayout
      title="Mentions légales"
      subtitle="Informations légales relatives au site et à son éditeur."
    >
      <H2>Éditeur du site</H2>
      <P>
        Le site est édité par LOOKING4, société par actions simplifiée (SAS),
        spécialisée dans le recrutement et le placement de profils techniques en
        CDI, notamment dans les domaines de la production, de la maintenance, de
        la R&D et de la supply chain.
      </P>
      <UL>
        <li>Dénomination sociale : SAS LOOKING4</li>
        <li>Siège social : 5 Avenue de l'Air du Temps, 44300 Nantes</li>
        <li>SIREN : 100 743 046</li>
        <li>SIRET : 100 743 046 00011</li>
        <li>RCS : Nantes</li>
        <li>
          Capital social : 1 000 euros
        </li>
        <li>
          Président et directeur de la publication : Christopher NICOL
        </li>
        <li>E-mail de contact : {CONTACT}</li>
        <li>Téléphone : 06 51 06 85 84</li>
        <li>Numéro de TVA intracommunautaire : FR42100743046</li>
      </UL>

      <H2>Hébergement</H2>
      <P>Le site est hébergé par :</P>
      <UL>
        <li>Nom de l'hébergeur : Infomaniak Network SA</li>
        <li>Adresse : Rue Eugène-Marziano 25, 1227 Les Acacias, Genève, Suisse</li>
        <li>
          Site internet :{" "}
          <a
            href="https://www.infomaniak.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#F5941E] hover:underline"
          >
            www.infomaniak.com
          </a>
        </li>
      </UL>

      <H2>Propriété intellectuelle</H2>
      <P>
        L'ensemble des éléments composant le présent site, notamment les textes,
        logos, visuels, photographies, graphismes, éléments techniques et
        structure du site, est protégé par le droit de la propriété
        intellectuelle.
      </P>
      <P>
        Toute reproduction, représentation, adaptation, modification ou
        exploitation, totale ou partielle, sans autorisation écrite préalable de
        LOOKING4, est interdite.
      </P>
      <P>
        La dénomination « LOOKING4 » est exploitée par la société LOOKING4.
      </P>

      <H2>Responsabilité</H2>
      <P>
        LOOKING4 s'efforce de fournir sur ce site des informations exactes et à
        jour. Toutefois, elle ne peut garantir l'exactitude, l'exhaustivité ou
        l'actualité de l'ensemble des informations diffusées.
      </P>
      <P>
        LOOKING4 ne pourra être tenue responsable des dommages directs ou
        indirects résultant de l'accès au site, de son utilisation ou de
        l'impossibilité d'y accéder.
      </P>

      <H2>Liens hypertextes</H2>
      <P>
        Le site peut contenir des liens vers des sites internet tiers. LOOKING4
        ne contrôle pas ces sites et ne saurait être responsable de leur
        contenu, de leur disponibilité ou de leur politique de confidentialité.
      </P>
    </LegalLayout>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      subtitle="Protection et traitement de vos données personnelles (RGPD)."
    >
      <H2>Responsable du traitement</H2>
      <P>
        Le responsable du traitement des données personnelles est la SAS
        LOOKING4, représentée par son Président, Christopher NICOL.
      </P>
      <P>Contact RGPD : {CONTACT}</P>

      <H2>Données collectées</H2>
      <P>
        Selon les formulaires utilisés, LOOKING4 peut collecter les données
        suivantes :
      </P>
      <UL>
        <li>nom, prénom, société, fonction ;</li>
        <li>adresse e-mail, numéro de téléphone ;</li>
        <li>contenu des demandes envoyées via le formulaire de contact ;</li>
        <li>
          pour les candidats : CV, parcours professionnel, compétences,
          expériences, prétentions salariales, disponibilités et toute
          information communiquée dans le cadre d'une candidature ou d'un
          échange de recrutement.
        </li>
      </UL>

      <H2>Finalités</H2>
      <P>Les données sont utilisées pour :</P>
      <UL>
        <li>répondre aux demandes envoyées via le formulaire de contact ;</li>
        <li>gérer les relations commerciales avec les prospects et clients ;</li>
        <li>
          réaliser des prestations de recrutement, de recherche, de
          présélection et de présentation de candidats ;
        </li>
        <li>
          assurer le suivi des candidatures et des échanges professionnels ;
        </li>
        <li>
          respecter les obligations légales, comptables et administratives de
          LOOKING4.
        </li>
      </UL>

      <H2>Bases légales</H2>
      <P>Les traitements sont fondés, selon les situations, sur :</P>
      <UL>
        <li>
          l'intérêt légitime de LOOKING4 à répondre aux demandes et développer
          ses relations professionnelles ;
        </li>
        <li>l'exécution de mesures précontractuelles ou contractuelles ;</li>
        <li>le respect d'obligations légales ;</li>
        <li>le consentement lorsque celui-ci est requis.</li>
      </UL>

      <H2>Destinataires des données</H2>
      <P>
        Les données sont accessibles uniquement aux personnes habilitées au sein
        de LOOKING4 ainsi qu'aux prestataires techniques strictement nécessaires
        au fonctionnement des outils utilisés.
      </P>
      <P>
        Dans le cadre d'un recrutement, les données d'un candidat peuvent être
        communiquées à une entreprise cliente uniquement lorsque cela est
        nécessaire à l'étude de sa candidature et dans le respect de
        l'information due au candidat.
      </P>

      <H2>Durées de conservation</H2>
      <UL>
        <li>
          Demandes de contact et données de prospects : 3 ans à compter du
          dernier contact.
        </li>
        <li>
          Données de candidats non retenus : 2 ans à compter du dernier contact,
          sauf opposition ou demande de suppression.
        </li>
        <li>
          Données liées à une relation contractuelle : pendant la durée de la
          relation contractuelle, puis pendant les durées légales applicables.
        </li>
        <li>
          Documents comptables et factures : 10 ans, conformément aux
          obligations légales.
        </li>
      </UL>

      <H2>Droits des personnes</H2>
      <P>
        Toute personne dispose d'un droit d'accès, de rectification,
        d'effacement, de limitation, d'opposition et, lorsque cela est
        applicable, de portabilité de ses données.
      </P>
      <P>Ces droits peuvent être exercés à l'adresse suivante : {CONTACT}</P>
      <P>
        En cas de difficulté, la personne concernée peut introduire une
        réclamation auprès de la CNIL :{" "}
        <a
          href="https://www.cnil.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#F5941E] hover:underline"
        >
          www.cnil.fr
        </a>
        .
      </P>

      <H2>Sécurité</H2>
      <P>
        LOOKING4 met en œuvre des mesures techniques et organisationnelles
        appropriées afin de protéger les données personnelles contre la perte,
        l'accès non autorisé, la divulgation, l'altération ou la destruction.
      </P>
    </LegalLayout>
  );
}

export function PolitiqueCookies() {
  return (
    <LegalLayout
      title="Politique cookies"
      subtitle="Utilisation des cookies et gestion de votre consentement."
    >
      <H2>Cookies utilisés</H2>
      <P>
        Le site utilise uniquement les cookies strictement nécessaires à son
        fonctionnement, sauf activation d'outils tiers tels que Google
        Analytics, Meta Pixel, Google Maps, vidéos YouTube ou widgets externes.
      </P>
      <P>
        Un outil de mesure d'audience (lemlist) peut être activé uniquement
        après votre consentement.
      </P>

      <H2>Votre consentement</H2>
      <P>
        Lorsque des cookies non essentiels sont utilisés, un bandeau s'affiche
        dès votre première visite et vous permet :
      </P>
      <UL>
        <li>d'accepter les cookies ;</li>
        <li>de refuser les cookies avec la même facilité ;</li>
        <li>de personnaliser vos choix ;</li>
        <li>
          de modifier ou retirer votre consentement à tout moment depuis le lien
          « Gérer mes cookies » présent dans le pied de page.
        </li>
      </UL>
      <P>
        Aucun cookie non essentiel n'est déposé avant votre consentement.
      </P>

      <H3>Gérer mes préférences</H3>
      <P>
        Vous pouvez à tout moment revenir sur votre choix en cliquant sur «{" "}
        <button
          onClick={() => window.dispatchEvent(new Event("l4-open-cookies"))}
          className="text-[#F5941E] hover:underline"
        >
          Gérer mes cookies
        </button>
        » (également disponible dans le pied de page).
      </P>
    </LegalLayout>
  );
}

export function CGV() {
  return (
    <LegalLayout
      title="Conditions Générales de Vente (CGV)"
      subtitle="Conditions applicables aux prestations de LOOKING4."
    >
      <P>
        Les Conditions Générales de Vente de LOOKING4 encadrent les prestations
        de recrutement, de recherche, de présélection et de présentation de
        candidats fournies à ses clients.
      </P>
      <P>
        Elles sont communiquées et acceptées lors de la conclusion de chaque
        mission. Le document complet est disponible sur simple demande à
        l'adresse {CONTACT}, ou sera mis à disposition en téléchargement (PDF)
        prochainement.
      </P>
      <P className="text-slate-400 italic">
        Version complète des CGV : à compléter / à mettre en ligne.
      </P>
    </LegalLayout>
  );
}
